export enum ItemTypeEnum {
    Site,
    SubSite,
    DocLibrary
}